import { ChevronLeft } from 'lucide-react';
import { ReactNode } from 'react';
import { Button } from '../../../design-system/button/button';
import { Inline } from '../../../design-system/inline/inline';
import { Stack } from '../../../design-system/stack/stack';
import { cn } from '../../../utils/cn';
import { PayrollAction } from '../use-payroll-flow';
import { getCurrentStepIndex, PAYROLL_STEPS } from '../utils/payroll-vertical-stepper-helpers';
import { VerticalStepper } from './vertical-stepper/vertical-stepper';

type PayrollFlowContentWrapperProps = {
  children: ReactNode;
  title?: string;
  isFullScreenWidth?: boolean;
  hideSidebar?: boolean;
  onGoBack: () => void;
  currentAction?: PayrollAction;
};

export const PayrollFlowContentWrapper = ({
  children,
  title,
  isFullScreenWidth = false,
  hideSidebar = false,
  onGoBack,
  currentAction,
}: PayrollFlowContentWrapperProps) => {
  const currentStepIndex = getCurrentStepIndex(currentAction);

  return (
    <div>
      <div className="flex h-full w-full flex-row">
        {!hideSidebar && (
          <aside
            className="min-w-[220px] border-r border-gray-200 bg-white px-8 py-10"
            aria-label="Payroll navigation sidebar"
          >
            <VerticalStepper
              steps={PAYROLL_STEPS.map((step) => ({ label: step.label, status: 'current' }))}
              currentStepIndex={currentStepIndex}
            />
          </aside>
        )}
        <div className="flex-1">
          <div
            className={cn('mx-auto w-[520px] py-10', {
              'w-full px-32': isFullScreenWidth,
            })}
          >
            <Stack space={3} align="stretch">
              <Inline space={3}>
                <Button variant="ghost" size="icon" className="bg-white" onClick={onGoBack} aria-label="Go back">
                  <ChevronLeft size={16} />
                </Button>

                {title && <h2 className="text-base font-medium text-black">{title}</h2>}
              </Inline>
              {children}
            </Stack>
          </div>
        </div>
      </div>
    </div>
  );
};
